// extracted by mini-css-extract-plugin
export var code = "contentful-rich-text-module--code--IqO9V";
export var heading1 = "contentful-rich-text-module--heading1---BCIO";
export var heading2 = "contentful-rich-text-module--heading2--vdwe7";
export var heading3 = "contentful-rich-text-module--heading3--LFPNW";
export var heading4 = "contentful-rich-text-module--heading4--zauOC";
export var listItem = "contentful-rich-text-module--list-item--U7fw5";
export var olList = "contentful-rich-text-module--ol-list--7OjKG";
export var quote = "contentful-rich-text-module--quote--CKqXZ";
export var ulList = "contentful-rich-text-module--ul-list--UYBkH";